import isEqual from 'lodash.isequal';
import { firstValueFrom } from 'rxjs';
import { waitForNext } from '../../operators';
import { map, distinctUntilChanged, skip, startWith } from 'rxjs/operators';
var SharedValueFunctionContext = /** @class */ (function () {
    function SharedValueFunctionContext(values) {
        this.values = values;
    }
    SharedValueFunctionContext.prototype.get = function (func) {
        return func(this.values);
    };
    SharedValueFunctionContext.prototype.waitFor = function (func, criteria) {
        return firstValueFrom(this.valueChanges(func).pipe(waitForNext(criteria)));
    };
    SharedValueFunctionContext.prototype.changes = function (func) {
        return this.valueChanges(func).pipe(skip(1)); //Skip the inital value
    };
    SharedValueFunctionContext.prototype.valueChanges = function (func) {
        var _this = this;
        // Potential performance improvement by recording values used in function and only watching for changes on them.
        return this.values
            .anyChanges()
            .pipe(map(function () { return func(_this.values); }))
            .pipe(startWith(func(this.values)), distinctUntilChanged(isEqual) // Deep equality check to preserve ref equality when values don't change
        );
    };
    return SharedValueFunctionContext;
}());
export { SharedValueFunctionContext };
//# sourceMappingURL=shared-value-function-context.js.map